export default "__VITE_ASSET__CdVwmnuW__"